import { gql } from 'apollo-boost';

export const getUsers = gql`
    query{
        users{
            _id,
            name,
            profile_info{
                label
            }
        }
    }
`;

export const getUserAuthorization = gql`
    query getUserAuthorization(
        $_id: ID!,
    ){
        user(
            _id: $_id
          ){
            _id,
            name,
            profile_info{
                _id,
                label
            }
        }
    }
`;


// WEBPACK FOOTER //
// ./src/graphql/query/users.js